<!--
 * @Author: Latte
 * @Date: 2021-09-10 09:13:23
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-17 15:39:42
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\User\userReview.vue
-->
<template>
	<div class="app-container">
		<div>
			<!-- 工具栏 -->
			<div class="topbar">
				<div class="left">
					<el-input v-model="searchValue" placeholder="城市/省/昵称/姓名/手机/组织" size="small"
						style="width: 450px; margin-right: 15px" @keyup.enter.native="search()" />
					<el-button type="primary" size="small" @click="search()">
						{{ $t("search") }}

					</el-button>
					<!-- <el-button type="info" size="small" @click="reset()">
            {{ $t("reset") }}
          </el-button> -->
				</div>

				<div class="right"></div>
			</div>

			<!-- 表格 -->
			<el-table v-loading="loading" :data="userReviewList" :header-cell-style="{ background: '#F5F7FA' }"
				style="width: 100%; margin-bottom: 20px" stripe border>
				<el-table-column prop="csVipUserID" label="ID" align="center" width="100" />
				<el-table-column show-overflow-tooltip prop="nickname" label="用户名" align="center" />
				<el-table-column prop="mobilePhone" label="手机号" align="center" />
				<el-table-column prop="organization" label="单位" align="center" show-overflow-tooltip />
				<el-table-column prop="sn" label="设备序列码" align="center" />
				<el-table-column label="设备信息" align="center">
					<template slot-scope="scope">
						{{scope.row.model!=null?scope.row.model:""}} {{scope.row.version!=null?scope.row.version:"" }}
					</template>
				</el-table-column>
				<el-table-column prop="operation" label="操作:授权/驳回" align="center" width="250">
					<template slot-scope="scope">
						<el-button type="success" size="small" title="Approve user"
							:disabled="scope.row.auditStatus === '1'" @click="approveReview(scope.row)">授权</el-button>
						<el-button type="warning" size="small" title="Unapprove user"
							:disabled="scope.row.auditStatus === '2'" @click="unapproveReview(scope.row)">驳回</el-button>
						<el-button type="danger" size="small" title="delete" @click="handleDeleteReview(scope.row)">
							删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div v-show="totalCount > pageSize" class="pagination">
				<el-pagination v-show="userReviewList.length > 0" background 
					:page-size="pageSize" :total="totalCount" :current-page="currentPage"
					@current-change="currentChange" />
			</div>
		</div>

		<!-- 系列 -->
		<el-dialog title="Series" :visible.sync="seriesListDialog" width="30%">
			<el-table :data="seriesList" style="width: 100%">
				<el-table-column prop="seriesName" label="仪器系列名" align="center" />
				<el-table-column prop="model" label="仪器型号" align="center" />
				<el-table-column prop="version" label="仪器版本号" align="center" />
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getUserReviewList,
		reviewUser,
		deleteUserReview
	} from "@/api/system/CSDocument/user";

	export default {
		data() {
			return {
				loading: false, // 加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 总数
				currentPage: 1, // 当前页码
				pageSize: 10, // 每页条数
				userReviewList: [], // 用户审核列表
				seriesListDialog: false, // 仪器系列对话框开关
				seriesList: [], // 仪器系列列表
			};
		},
		created() {
			this.getUserReviewList();
		},
		methods: {
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.getUserReviewList();
			},
			/**
			 * 搜索
			 */
			search() {
				// if (!this.searchValue) {
				// 	this.$message({
				// 		message: "The search input cannot be empty.",
				// 		type: "warning",
				// 	});
				// 	return;
				// }
				this.currentPage = 1;
				this.getUserReviewList();
			},
			/**
			 * 重置
			 */
			reset() {
				this.searchValue = "";
				this.currentPage = 1;
				this.getUserReviewList();
			},
			/**
			 * 获取用户审核列表
			 */
			getUserReviewList() {
				let params = {
					sortName: "",
					sortOrder: "",
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					keyWord: this.searchValue,
					where: "",
				};
				this.loading = true;

				getUserReviewList(params).then((res) => {
					this.userReviewList = res.data.rows;
					this.totalCount = res.data.total;
					this.utils.stopLoading(this);
				});
			},
			/**
			 * 接受申请
			 * @param {Object} row
			 */
			approveReview(row) {
				this.reviewUser(row.csVipUserID, 1, "")
			},
			/**
			 * 驳回申请
			 * @param {Object} row
			 */
			unapproveReview(row) {
				//填写拒绝原因
				this.$prompt('请输入驳回原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					this.reviewUser(row.csVipUserID, 2, value)
				}).catch(() => {

				});
			},
			/**
			 * 更改用户审核状态
			 *
			 * @param {object} row 选中对象
			 * @param {number} status 状态
			 */
			reviewUser(csvipUserID, status, reason) {
				const data = {
					csVipUserID: csvipUserID,
					status: status,
					reason: reason,
				};
				reviewUser(data).then((res) => {
					if (res.code === 200) {
						this.$message({
							message: "操作成功",
							type: "success",
						});
					} else {
						this.$message({
							message: res.message,
							type: "warning",
						});
						return;
					}

					this.getUserReviewList();
				});
			},
			/**
			 * 处理删除申请
			 * 当未审核时，提示用户会驳回，确认后走驳回删除
			 * 其他，提示用户，确认后删除
			 */
			async handleDeleteReview(row) {
				//未审核
				if (row.auditStatus === "0") {
					let res = await this.$confirm('删除该记录将自动驳回该请求，是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).catch(() => {
						return
					})
					if (res !== 'confirm') {
						return;
					}
					this.reviewUser(row.csVipUserID,2,'')
				} else {
					let res = await this.$confirm('确认删除该记录?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).catch(() => {
						return
					})
					if (res !== 'confirm') {
						return;
					}
				}

				this.deleteUserReview(row.csVipUserID)
			},

			deleteUserReview(csVipUserID) {
				deleteUserReview(csVipUserID).then((res) => {
					if (res.code === 200) {
						this.$message({
							message: "操作成功",
							type: 'sucess'
						})
					} else {
						this.$message({
							message: res.message,
							type: "warning",
						});
						return;
					}
					this.getUserReviewList()
				});
			}
		},
	};
</script>

<style scoped lang="scss">

</style>
